import React from 'react';

export const BackwardButton = ({label, handleClick}) => {
  return (
    <button className='btn btn-block btn-pill btn-white btn-fill-h' onClick={handleClick}>
      <span>{label}</span>
    </button>
  );
};